/**
 * @global $
 * @global Backbone
 * @global gettext
 * @global userPasswordChangeUrl
 */
(function () {
  "use strict";

  var PasswordChangeView = (window.PasswordChangeView = Backbone.View.extend({
    el: "#form_change_password",

    events: {
      submit: "submit",
    },

    initialize: function () {
      this.$success = this.$el.find(".success");
      this.$failure = this.$el.find(".failure");
      this.$loading = this.$el.find(".progress");

      $.getJSON(userPasswordChangeUrl, function (response) {
        $("[name=csrfmiddlewaretoken]").val(response.token);
        $(".loading").removeClass("loading");
      });
    },

    submit: function (e) {
      e.preventDefault();

      this.$loading.show();
      this.$failure.hide();
      this.$success.hide();

      $.post(
        userPasswordChangeUrl,
        this.$el.serialize(),
        function (response) {
          response = JSON.parse(response);
          this.$loading.hide();

          if (response.success) {
            topbar.notify("Password changed", "success");
            this.$el[0].reset();
          } else {
            var $msg = $("<dl>");
            response.error.description.forEach(function (err) {
              $msg.append($("<dd>").text(err));
            });
            topbar.notify($msg, "error");
          }
        }.bind(this)
      );
    },
  }));
})();
